function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var secondsOfOneDay = 86400;
export var nameOfDays = ['日', '一', '二', '三', '四', '五', '六'];
export var nameOfMonths = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
export var todayDate = new Date();
export var todayDateObj = {
  year: todayDate.getFullYear(),
  month: todayDate.getMonth(),
  day: todayDate.getDate()
};
export var getValueFromDateObj = function getValueFromDateObj(dateObj) {
  return "".concat(dateObj.year, "-").concat(dateObj.month + 1, "-").concat(dateObj.day);
};
export var getDateObjFromValue = function getDateObjFromValue(value) {
  var arr = value.split('-');
  return {
    year: Number(arr[0]),
    month: Number(arr[1]) - 1,
    day: Number(arr[2])
  };
};
export var getEndDateOfMonth = function getEndDateOfMonth(year, month) {
  // month超过12会自动进位到年，无需特殊处理
  var nextMonth = new Date(year, month + 1, 1);
  return new Date(nextMonth.getTime() - secondsOfOneDay).getDate();
};
export var checkToday = function checkToday(year, month, day) {
  return year === todayDateObj.year && month === todayDateObj.month && day === todayDateObj.day;
};
export var checkSelected = function checkSelected(_ref, _ref2) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  var selectedYear = _ref2.year,
      selectedMonth = _ref2.month,
      selectedDay = _ref2.day;
  return year === selectedYear && month === selectedMonth && day === selectedDay;
};
export var getDateList = function getDateList(dateObj, selectedDateObj) {
  var year = dateObj.year,
      month = dateObj.month; // const selectedYear = selectedDateObj.year;
  // const selectedMonth = selectedDateObj.month;
  // const selectedDay = selectedDateObj.day;
  // 获取1号是星期几

  var firstDayOfWeek = new Date(year, month, 1).getDay();
  var endDate = getEndDateOfMonth(year, month);
  var list = []; // prev month
  // 如果此月第一天不是星期日, 则从前一月中填充

  if (firstDayOfWeek !== 0) {
    var prevYear = month > 0 ? year : year - 1;
    var prevMonth = month > 0 ? month - 1 : 11;
    var endDateOfPrevMonth = getEndDateOfMonth(prevYear, prevMonth);

    for (var i = firstDayOfWeek; i > 0; i -= 1) {
      var idate = endDateOfPrevMonth - (i - 1);
      list.push({
        dateObj: {
          year: prevYear,
          month: prevMonth,
          day: idate
        },
        curMonth: false,
        curDay: false,
        active: false,
        disabled: true
      });
    }
  } // cur month


  for (var _i = 1; _i <= endDate; _i += 1) {
    var curDateObj = {
      year: year,
      month: month,
      day: _i
    };
    list.push({
      dateObj: curDateObj,
      curMonth: true,
      curDay: checkToday(year, month, _i),
      active: checkSelected(curDateObj, selectedDateObj),
      disabled: false
    });
  } // next month


  if (list.length < 42) {
    var nextYear = month < 11 ? year : year + 1;
    var nextMonth = month < 11 ? month + 1 : 0;
    var nextMonthDays = 42 - list.length;

    for (var _i2 = 1; _i2 <= nextMonthDays; _i2 += 1) {
      list.push({
        dateObj: {
          year: nextYear,
          month: nextMonth,
          day: _i2
        },
        curMonth: false,
        curDay: false,
        active: false,
        disabled: true
      });
    }
  }

  return list;
};
export var FixDateListSelected = function FixDateListSelected(dateList, selectedDateObj) {
  return dateList.map(function (dateItem) {
    return _objectSpread({}, dateItem, {
      active: checkSelected(dateItem.dateObj, selectedDateObj)
    });
  });
};
export var dateBigger = function dateBigger(date1, date2) {
  if (date1.year > date2.year) return true;
  if (date1.year < date2.year) return false;
  if (date1.month > date2.month) return true;
  if (date1.mongth < date2.month) return false;
  if (date1.day > date2.day) return true;
  return false;
};
export var dateEqual = function dateEqual(date1, date2) {
  if (!date1 || !date2) return false;
  return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
};